"use strict";
//#region Util Imports
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_es_1 = require("lodash-es");
//#endregion
var base_1 = require("../../../components/base");
var OverlayController = /** @class */ (function (_super) {
    tslib_1.__extends(OverlayController, _super);
    //#endregion
    //#region Ctor
    function OverlayController() {
        var _this = _super.call(this) || this;
        //#region Members
        _this.isCloseConfirmed = false;
        //#endregion
        //#region Popup
        _this.overlayOptions = null;
        _this.overlay = null;
        //#endregion
        //#region Overlay Content
        _this.overlayContentOptions = null;
        _this.overlayContent = null;
        return _this;
    }
    //#endregion
    //#region Lifecycle
    OverlayController.prototype.initialize = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initializeOverlayContent();
                        return [4 /*yield*/, this.initializeOverlay()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OverlayController.prototype.destroy = function () {
        var _a;
        (_a = this.overlay) === null || _a === void 0 ? void 0 : _a.dispose();
    };
    //#endregion
    //#region Overlay Implementation
    OverlayController.prototype.hide = function () {
        var _a;
        (_a = this.overlay) === null || _a === void 0 ? void 0 : _a.hide();
    };
    OverlayController.prototype.isVisible = function () {
        if (this.overlay != null) {
            return this.overlay.option('visible');
        }
        return false;
    };
    OverlayController.prototype.toggle = function (isVisible) {
        var _a;
        (_a = this.overlay) === null || _a === void 0 ? void 0 : _a.toggle(isVisible);
    };
    OverlayController.prototype.hideLoading = function () {
        var _a;
        (_a = this.overlayContent) === null || _a === void 0 ? void 0 : _a.hideLoading();
    };
    OverlayController.prototype.showLoading = function () {
        var _a;
        (_a = this.overlayContent) === null || _a === void 0 ? void 0 : _a.showLoading();
    };
    OverlayController.prototype.toggleLoading = function (isLoading) {
        var _a;
        (_a = this.overlayContent) === null || _a === void 0 ? void 0 : _a.toggleLoading(isLoading);
    };
    //#endregion
    //#region Events
    OverlayController.prototype.onHiding = function () {
        var eventArgs = {
            component: this,
            cancelAsync: null
        };
        _super.prototype.callEvent.call(this, this.options.onHiding, eventArgs);
        return {
            cancelAsync: eventArgs.cancelAsync
        };
    };
    OverlayController.prototype.initializeOverlay = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.prepareOverlayOptions();
                        return [4 /*yield*/, this.waitForOverlayInitialized()];
                    case 1:
                        _a.sent();
                        this.registerOverlayEvents();
                        return [2 /*return*/];
                }
            });
        });
    };
    // tslint:disable-next-line:no-empty
    OverlayController.prototype.configureOverlay = function (options) { };
    OverlayController.prototype.prepareOverlayOptions = function () {
        var _a;
        this.overlayOptions = (_a = lodash_es_1.cloneDeep(this.options.innerOptions)) !== null && _a !== void 0 ? _a : {};
        if (this.overlayOptions != null) {
            if (this.options.width !== undefined) {
                this.overlayOptions.width = this.options.width;
            }
            this.configureOverlay(this.overlayOptions);
        }
    };
    OverlayController.prototype.waitForOverlayInitialized = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var overlayInitializedArgs;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.overlayOptions != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, _super.prototype.waitForOnInitialized.call(this, this.overlayOptions)];
                    case 1:
                        overlayInitializedArgs = _b.sent();
                        this.overlay = (_a = overlayInitializedArgs.component) !== null && _a !== void 0 ? _a : null;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    OverlayController.prototype.registerOverlayEvents = function () {
        var _this = this;
        if (this.overlay != null) {
            this.overlay.on('hiding', function (e) { return _this.onOverlayHiding(e); });
        }
    };
    OverlayController.prototype.onOverlayHiding = function (e) {
        var _this = this;
        if (this.isCloseConfirmed === false) {
            var eventResult = this.onHiding();
            if (eventResult != null && eventResult.cancelAsync != null) {
                e.cancel = true;
                eventResult.cancelAsync.then(function (isCanceled) {
                    if (!isCanceled) {
                        _this.isCloseConfirmed = true;
                        _this.hide();
                    }
                });
            }
        }
        this.isCloseConfirmed = false;
    };
    OverlayController.prototype.initializeOverlayContent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.prepareOverlayContentOptions();
                        return [4 /*yield*/, this.waitForOverlayContentInitialized()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OverlayController.prototype.prepareOverlayContentOptions = function () {
        this.overlayContentOptions = {
            bottomToolbarOptions: this.options.bottomToolbarOptions
        };
    };
    OverlayController.prototype.waitForOverlayContentInitialized = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var overlayInitializedArgs;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.overlayContentOptions != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, _super.prototype.waitForOnInitialized.call(this, this.overlayContentOptions)];
                    case 1:
                        overlayInitializedArgs = _b.sent();
                        this.overlayContent = (_a = overlayInitializedArgs.component) !== null && _a !== void 0 ? _a : null;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return OverlayController;
}(base_1.IMRBaseComponentController));
exports.OverlayController = OverlayController;
//# sourceMappingURL=overlay.controller.js.map